import { Box, Button, Card, CircularProgress, Grid, Modal, Stack, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { insertCustomerApi, updateCustomerApi } from "src/api/customerApi";
import FormikInput from "src/components/FormikInput ";
import { notification } from "src/utils/messages";
import * as Yup from "yup";
import Select from "react-select";
import { getCityListByStateApi, getStateListApi } from "src/api/invoiceApi";

export default function CustomerInsertUpdateModal({
  addEditModal = false,
  toggleAddEditModal = () => {},
  modalType = "Add",
  rowData = {},
  getCustomerMethod = () => {},
  getCustomerListForInvoice = () => {}
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2,
    maxHeight: "90vh",
    overflowY: "auto"
  };

  const [loader, setLoader] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const getStateList = async () => {
    try {
      const resp = await getStateListApi();
      if (resp.status == 1) {
        setStateList(resp.data);
      }
    } catch (error) { }
  };

  const getCityList = async (stateId) => {
    try {
      const resp = await getCityListByStateApi({ state_id: stateId });
      if (resp.status == 1) {
        setCityList(resp.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getStateList();
  }, []);

  useEffect(() => {
    if (modalType === "Edit" && rowData?.state_id) {
      getCityList(rowData.state_id);
    }
  }, [rowData]);

  const handleCustomerSubmit = async (data) => {
    if (modalType === "Edit") {
      setLoader(true);
      let resp = await updateCustomerApi({
        ...data,
        c_id: rowData.c_id
      });
      if (resp.status != 0) {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();

        toggleAddEditModal();
        getCustomerMethod();
        getCustomerListForInvoice({ pageNo: 1, searchText: "" });
      } else {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
      }
      setLoader(false);
    } else {
      setLoader(true);
      let resp = await insertCustomerApi(data);
      if (resp.status != 0) {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();

        toggleAddEditModal();
        getCustomerMethod();
        getCustomerListForInvoice({ pageNo: 1, searchText: "" });
      } else {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
      }
      setLoader(false);
    }
  };

  const validationSchema = Yup.object({
    c_name: Yup.string().required("Customer Name is required"),
    c_company_name: Yup.string().required("Company Name is required"),
    c_mono: Yup.string()
      .required("Contact Number is required")
      .matches(/^[0-9]{10}$/, "Enter valid 10 digit mobile number"),
    c_email: Yup.string().email("Enter valid email address")
  });

  return (
    <Modal
      open={addEditModal}
      onClose={() => toggleAddEditModal()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          style={{ marginBottom: "5px", textAlign: "center" }}
        >
          {modalType} Customer
        </Typography>
        <hr />

        <Formik
          initialValues={{
            c_name: modalType === "Edit" ? rowData?.c_name : "",
            c_company_name: modalType === "Edit" ? rowData?.c_company_name : "",
            c_email: modalType === "Edit" ? rowData?.c_email : "",
            c_mono: modalType === "Edit" ? rowData?.c_mono : "",
            c_gst_no: modalType === "Edit" ? rowData?.c_gst_no : "",
            c_company_pan_no: modalType === "Edit" ? rowData?.c_company_pan_no : "",
            c_address: modalType === "Edit" ? rowData?.c_address : "",
            state_id: modalType === "Edit" ? rowData?.state_id : "",
            city_id: modalType === "Edit" ? rowData?.city_id : ""
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => handleCustomerSubmit(values)}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <Grid container spacing={2} sx={{ alignItems: "flex-start", mt: "5px" }}>
                <Grid item xs={12}>
                  <FormikInput name="c_name" label="Customer Name" required />
                </Grid>
                <Grid item xs={12}>
                  <FormikInput name="c_company_name" label="Company Name" required />
                </Grid>
                <Grid item xs={12}>
                  <FormikInput name="c_email" label="Company Email" type="email" />
                </Grid>
                <Grid item xs={12}>
                  <FormikInput
                    name="c_mono"
                    label="Company Contact No"
                    required
                    numericOnly={true}
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormikInput name="c_gst_no" label="Company GST No" />
                </Grid>
                <Grid item xs={6}>
                  <FormikInput name="c_company_pan_no" label="Company PAN No" />
                </Grid>
                <Grid item xs={12}>
                  <FormikInput name="c_address" label="Company Address" multiline={true} rows={3} />
                </Grid>
                <Grid item xs={6} sx={{ mt: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                    State
                  </Typography>
                  <Select
                    options={stateList?.map((s) => ({
                      label: s?.state_name,
                      value: s?.state_id
                    }))}
                    value={
                      stateList
                        ?.map((s) => ({
                          label: s?.state_name,
                          value: s?.state_id
                        }))
                        ?.find((option) => option.value == values.state_id) || null
                    }
                    onChange={(selectedOption) => {
                      setFieldValue("state_id", selectedOption ? selectedOption.value : "");
                      setFieldValue("city_id", "");
                      setCityList([]);
                      if (selectedOption) {
                        getCityList(selectedOption.value);
                      }
                    }}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </Grid>
                <Grid item xs={6} sx={{ mt: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                    City
                  </Typography>
                  <Select
                    options={cityList?.map((c) => ({
                      label: c?.city_name,
                      value: c?.city_id
                    }))}
                    value={
                      cityList
                        ?.map((c) => ({
                          label: c?.city_name,
                          value: c?.city_id
                        }))
                        ?.find((option) => option.value == values.city_id) || null
                    }
                    onChange={(selectedOption) => {
                      setFieldValue("city_id", selectedOption ? selectedOption.value : "");
                    }}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </Grid>
                <Grid
                  item
                  sm={12}
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center"
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => toggleAddEditModal()}
                    style={{ marginTop: "15px", marginRight: "15px" }}
                  >
                    Close
                  </Button>
                  <Button
                    variant="contained"
                    style={{ marginTop: "15px" }}
                    type="submit"
                    disabled={loader}
                  >
                    Submit
                    {loader && (
                      <CircularProgress size={14} color="inherit" sx={{ marginLeft: "10px" }} />
                    )}
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}
